import { SellerAxiosRequestConfig } from '../axios';
import { SWAGGER_INBOUND_URL, SWAGGER_MOCK_SELLER_URL } from '../endpoints';
import request from '../request';

const cleanSwagger = (swagger: any, serverPath: string) => {
  if (!swagger || typeof swagger !== 'object') return swagger;

  // Remove info section as we display our own framing
  delete swagger.info;

  // Remove health check endpoint as those are internal for us
  Object.keys(swagger.paths).forEach((path) => {
    if (path.includes('/api/v1/health')) {
      delete swagger.paths[path];
    }
  });

  swagger.servers = [
    {
      url: serverPath,
    },
  ];

  return swagger;
};

export default class SwaggerService {
  static readonly fetchInboundSwagger = async (serverPath: string) => {
    const response = await request<any>({
      url: `${SWAGGER_INBOUND_URL}`,
      method: 'get',
      keepCasing: true,
    } as SellerAxiosRequestConfig);
    return cleanSwagger(response, serverPath);
  };

  static readonly fetchOutboundSwagger = async (serverPath: string) => {
    const response = await request<any>({
      url: `${SWAGGER_MOCK_SELLER_URL}`,
      method: 'get',
      keepCasing: true,
    } as SellerAxiosRequestConfig);
    return cleanSwagger(response, serverPath);
  };
}
